export default __webpack_public_path__ + "static/media/user-logo.a3b555aa.svg";